import { useState } from 'react';

export default function VoiceScreen({ user, userData }) {
  const [inRoom, setInRoom]   = useState(false);
  const [muted, setMuted]     = useState(false);
  const [confirm, setConfirm] = useState(false);

  const roommates = [
    { initials: 'RZ', bg: '#1f2535', text: '#93c5fd', name: 'Reza', muted: true },
  ];

  return (
    <div className="screen">
      <div className="screen-header">
        <div className="screen-title">voice room</div>
      </div>

      <div className="scroll-area">
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
            {inRoom ? '🟢 you\'re in the room' : 'join to talk with your crew'}
          </div>
        </div>

        <div className="speaker-grid">
          {inRoom && (
            <div className="speaker-tile">
              <div className="speaker-avatar speaking" style={{ background: userData?.avatarBg, color: userData?.avatarText }}>
                {userData?.initials}
                {muted && (
                  <div className="mute-icon"><i className="ti ti-microphone-off" /></div>
                )}
              </div>
              <div className="speaker-name">You</div>
            </div>
          )}
          {roommates.map((r, i) => (
            <div key={i} className="speaker-tile">
              <div className="speaker-avatar" style={{ background: r.bg, color: r.text }}>
                {r.initials}
                {r.muted && <div className="mute-icon"><i className="ti ti-microphone-off" /></div>}
              </div>
              <div className="speaker-name">{r.name}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="voice-controls">
        <div className="voice-btn" onClick={() => setMuted(m => !m)}>
          <button className="voice-btn-circle mute">
            <i className={`ti ${muted ? 'ti-microphone-off' : 'ti-microphone'}`} />
          </button>
          <span className="voice-btn-label">{muted ? 'unmute' : 'mute'}</span>
        </div>

        <div className="voice-btn" onClick={() => !inRoom && setInRoom(true)}>
          <button className="voice-btn-circle join" style={inRoom ? { background: 'rgba(74,222,128,0.15)', color: 'var(--online)' } : {}}>
            <i className={`ti ${inRoom ? 'ti-user-check' : 'ti-headphones'}`} />
          </button>
          <span className="voice-btn-label">{inRoom ? 'in room' : 'join'}</span>
        </div>

        <div className="voice-btn" onClick={() => setConfirm(true)}>
          <button className="voice-btn-circle leave">
            <i className="ti ti-phone-off" />
          </button>
          <span className="voice-btn-label">leave</span>
        </div>
      </div>

      {confirm && (
        <div className="confirm-dialog">
          <div className="confirm-box">
            <div className="confirm-title">Leave room?</div>
            <div className="confirm-sub">You'll disconnect from the voice room.</div>
            <div className="confirm-btns">
              <button className="btn-cancel" onClick={() => setConfirm(false)}>Cancel</button>
              <button className="btn-danger" onClick={() => { setInRoom(false); setConfirm(false); }}>Leave</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
